/* src/app/components/doc-viewer-new/doc-viewer-bottom-right-bar/doc-viewer-bottom-right-bar.component.scss */
.tabs {
  background: rgb(36, 62, 144);
}
.tab-text {
  color: #fff;
}
.icon-container {
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  font-size: 21px;
  cursor: pointer;
}
.selected {
  background: #fff;
}
.selected .tab-text {
  color: #05136b;
}
.selected-icon {
  --fa-primary-color: #243e90;
  --fa-secondary-color: #a6b1d2;
  --fa-secondary-opacity: 1;
}
.icon {
  --fa-primary-color: #fff;
  --fa-secondary-color: #fff;
  --fa-secondary-opacity: 0.4;
}
:host-context(.dark-theme) .tabs {
  background: #0E0D0D;
}
:host-context(.dark-theme) .tab-text {
  color: #FFF;
}
:host-context(.dark-theme) .selected {
  background: #252525;
}
:host-context(.dark-theme) .selected-icon {
  --fa-primary-color: #8d8d8d;
  --fa-secondary-color: #FFC107;
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #6c6c6c;
  --fa-secondary-color: #FFC107;
  --fa-secondary-opacity: 1;
  color: initial;
}
/*# sourceMappingURL=doc-viewer-bottom-right-bar.component.css.map */
